/**
 * Only the auth guard's own "unauthenticated" answer (or a bare 401) means the
 * session is over. A 401 that carries any other business code — a wrong email
 * code, a wrong password, "no password yet" — is an ordinary form error: the
 * person must stay where they are, with what they typed.
 */
const SESSION_EXPIRED_CODES = new Set(['Identity.Authentication.Unauthenticated'])

export function isSessionExpiredError(error: unknown): boolean {
  const response = (error as { response?: { status?: number; data?: { code?: string } } })?.response
  if (response?.status !== 401) return false
  const code = response.data?.code
  return !code || SESSION_EXPIRED_CODES.has(code)
}
